import { nanoid } from 'nanoid';
import { type UserContent } from '@/components/with_auth/State';

// First we try to set it to the user's full name
// and if that doesn't work try to append some numbers
export const tryToSetBriefKey = (user: UserContent): string => {
    // First try to set it to their full name,
    // if that doesn't work fall back to nanoid
    let count = 0;
    let briefKey = null;
    while (!briefKey) {
        briefKey = user.fullName
            // replace any non-word character in full name with a .
            ? user.fullName.trim().toLowerCase().replace(/\W/g, '.')
            : nanoid();

        // adjust key based on tries, appends 1,2,3 and so on until
        // we find a free key
        briefKey = `${briefKey}${count || ''}`;

        for (let i = 0; i < user.briefs.length; i++) {
            const brief = user.briefs[i];
            if (brief.displayKey === briefKey) {
                // Oops, matches, clear it
                briefKey = null;
                count += 1;
            }
        }

        if (count > 500) {
            // how did we screw this up
            briefKey = nanoid();
            break;
        }
    }

    return briefKey;
};

export const BIO_GEN_TEMPERATURE = 0.25;

export const GENERIC_ERROR_TEXT = 'An unexpected error occurred.';
